/**
 * Business function. Treats entries from API.
 * @param {object} response The response of the API
 * @returns {object} The response treated.
 */
const treatsEntities = (response) => response.data.items.sort((a) => a.id);

export default treatsEntities;
